// ======================================================================
// File Name       : importList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { IMPORT_LIST_RECEIVE_RESULT } from '../constants/ActionTypes';

const initialState = {
  result: {
    recordNum: 0,
    importResultList: [],
  },
};

export default function importList(state = initialState, action) {
  switch (action.type) {
    case IMPORT_LIST_RECEIVE_RESULT: {
      const { result = {} } = action;
      const { recordNum = 0, importResultList = [] } = result;
      return { result: { recordNum, importResultList } };
    }

    default:
      return state;
  }
}
